interface Props {
  status: string;
  variant?: 'default' | 'success' | 'warning' | 'muted';
}

export function StatusBadge({ status, variant = 'default' }: Props) {
  return <span className={`badge badge--${variant}`}>{status.replace(/_/g, ' ')}</span>;
}
